/**
 * MEXC timeframe configuration.
 * REST: 1m, 5m, 15m, 30m, 60m, 4h, 8h, 1d, 1W, 1M
 * WS: Min1, Min5, Min15, Min30, Min60, Hour4, Hour8, Day1, Week1, Month1
 * NOTE: MEXC does NOT support 3m, 10m, 2h, 6h, 12h, 2d, 3d, 5d intervals!
 * @see https://www.mexc.com/api-docs/spot-v3/public-api-definitions#kline-interval
 */

import { registerExchangeTimeframes, type TimeframeConfig } from '../../lib/timeframes';

/**
 * MEXC supported kline intervals.
 */
export const MEXC_TIMEFRAMES: TimeframeConfig = {
  native: ['1m', '5m', '15m', '30m', '1h', '4h', '8h', '1d', '1w', '1M'],
  synthetic: ['1s'], // Use ticker for 1s
  minIntervalSeconds: 60,
};

// Register with central registry
registerExchangeTimeframes('mexc', MEXC_TIMEFRAMES);

// Note: mapToMexcInterval is exported from ./rest.ts to avoid duplication
